var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 88 88"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#D0D7DE",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474D55",
    fillRule: "nonzero",
    d: "M44 57a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1m.113-27.999c4.288.06 7.826 3.598 7.886 7.885a7.96 7.96 0 0 1-3.667 6.84C46.276 45.053 45 47.516 45 50.158V53a1 1 0 1 1-2 0v-2.842c0-3.364 1.588-6.396 4.248-8.112a5.97 5.97 0 0 0 2.751-5.132c-.044-3.161-2.752-5.869-5.913-5.913-1.611-.038-3.146.59-4.299 1.727A5.96 5.96 0 0 0 38 37a1 1 0 1 1-2 0c0-2.158.847-4.181 2.383-5.696A7.94 7.94 0 0 1 43.998 29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8A929B",
    fillRule: "nonzero",
    d: "M44 18c-14.337 0-26 11.663-26 26s11.663 26 26 26 26-11.663 26-26-11.663-26-26-26m0 50c-13.233 0-24-10.767-24-24s10.767-24 24-24 24 10.767 24 24-10.767 24-24 24"
  }))));
};
export default SvgQuestion;